import { theme } from "./constants";
import type { Theme } from "./types";

export function useTheme(): Theme {
    return theme;
}
